import type { Transaction } from "@rocicorp/zero";
import * as z from "zod";
import { userFacingError } from "../authorization";
import { rootDomain } from "../connectors/urlDomain";
import { type Schema, zql } from "../generatedDrizzleSchema";

export const domainConfig = {
  resolve: {},
  schema: z.object({
    id: z.string().min(1).max(64),
  }),
  permissions: [
    {
      permission: "allow_all",
      scopeId: ({ ctx }: { ctx: { tenantId: string } }) => ctx.tenantId,
    },
  ],
} as const;

export function findSetup(
  tx: Transaction<Schema>,
  tenantId: string,
  key: { id: string }
) {
  return tx.run(
    zql.customDomainSetups.where("tenantId", tenantId).where("id", key.id).one()
  );
}

export function assertSpaceDomain(domain: string, spaceId?: string | null) {
  if (spaceId && rootDomain(domain) === domain)
    throw userFacingError(
      "Use a subdomain such as www.example.com for a space."
    );
}
